import {Action, Dispatch} from 'redux';
import {
  AuthActions,
  FETCH_USER_EMAIL,
  FETCH_USER_EMAIL_ERROR,
  FETCH_USER_EMAIL_SUCCESS,
  LOG_OUT,
  LOGIN_START,
  LOGIN_SUCCESS,
} from '../../types/actions/Auth.actions';
import Api, {
  ADMINS_URL,
  LOGIN_CHALLENGE_URL,
  LOGIN_URL,
  LoginResponse,
} from '../../@crema/services/ApiConfig';
import {IState} from '../reducers';
import {showError} from '../../redux/actions';
import {CommonActionTypes} from '../../types/actions/Common.action';
import {ApiActionCall, ApiActionTypes} from './Api';
import {IAdmin} from '../../types/models/Admin';

const loginSuccess = (token: string, address: string): AuthActions => ({
  type: LOGIN_SUCCESS,
  payload: {
    token,
    address,
  },
});

export const loginUser =
  (ethAddress: string) =>
  async (
    dispatch: Dispatch<AuthActions | CommonActionTypes | ApiActionCall>,
    getState: () => IState,
  ) => {
    dispatch({type: LOGIN_START});
    try {
      const challenge = await Api.get(LOGIN_CHALLENGE_URL, {
        params: {ethAddress},
      });
      const provider = getState().web3.provider;
      if (provider) {
        const signer = await provider.getSigner();
        const address = await signer.getAddress();
        const signature = await provider.send('eth_signTypedData_v4', [
          address,
          JSON.stringify(challenge.data),
        ]);
        const response: LoginResponse = await Api.post(LOGIN_URL, {
          signature,
          message: challenge.data.message.value,
        });

        fetchUserEmail(response.data.token, address)(dispatch, getState);
        dispatch(loginSuccess(response.data.token, address));
      }
    } catch (e: any) {
      let message = e instanceof Error ? e.message : String(e);

      if (
        e?.code === 'ACTION_REJECTED' ||
        message.includes('ACTION_REJECTED') ||
        message.includes('user rejected')
      ) {
        message = 'Signature request was cancelled.';
      }

      dispatch(showError(message));
    }
  };

export const logoutUser = () => (dispatch: Dispatch<AuthActions>) => {
  dispatch({type: LOG_OUT});
};

export const fetchUserEmail =
  (token?: string, adress?: string) =>
  (dispatch: Dispatch<ApiActionCall | AuthActions>, getState: () => IState) => {
    dispatch({type: FETCH_USER_EMAIL});
    const state = getState();

    const onSuccess = (payload: IAdmin[]) => {
      const authAddress = state.auth.user?.address || '';
      const admin = payload.find(
        ({address: payloadAddress}) =>
          (adress || authAddress).toLowerCase() ===
          payloadAddress.toLowerCase(),
      );
      return {
        type: FETCH_USER_EMAIL_SUCCESS,
        payload: admin?.email || '',
      };
    };
    const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
      dispatch({type: FETCH_USER_EMAIL_ERROR});
      dispatch(showError('Failed to fetch admin email.'));
    };

    dispatch({
      type: ApiActionTypes.API_CALL,
      payload: {
        url: ADMINS_URL,
        method: 'GET',
        token,
        label: 'Fetch admin list',
        onSuccess,
        onFailure,
      },
    });
  };
